import Repository from "../repository";

export default class Data extends Repository {
    constructor(dataSource) {
        super(dataSource);
    }

    countries() {
        return this.dataSource.get(`data/countries`).then(({data}) => data)
    }

    signUp() {
        return this.dataSource.get('data/sign-up').then(({data}) => data)
    }

    encounters(page = 0) {
        return this.dataSource.get(`encounters/${page}`).then(({data}) => data)
    }

    encountersWithTests(page = 0) {
        return this.dataSource.get(`test-groups/${page}`).then(({data}) => data)
    }

    patientVaccines(page = 0) {
        return this.dataSource.get(`vaccines/${page}`).then(({data}) => data)
    }

    practitioners(type = null, query = null, specialization = null) {
        return this.dataSource.get(`practitioners`, {
            params: {type, query, specialization: type === 1 ? specialization : null}
        }).then(({data}) => data)
    }

    specializations() {
        return this.dataSource.get('specializations').then(({data}) => data);
    }

    patientWallets(page = 0) {
        return this.dataSource.get(`wallets/${page}`).then(({data}) => data)
    }

    deletePatientWallet(id) {
        return this.dataSource.delete(`wallets/${id}`).then(({data}) => data)
    }

    addPatientWallet(formData) {
        return this.dataSource.post('wallets', formData).then(({data}) => data)
    }

    healthCareProviders(page = 0) {
        return this.dataSource.get(`health-care-providers/${page}`).then(({data}) => data)
    }

    feedBack(formData) {
        return this.dataSource.post('feed-back', formData).then(({data}) => data);
    }

    getRoute(lat1, lon1, lat2, lon2) {
        return this.dataSource.request({
            url: `https://api.mapbox.com/directions/v5/mapbox/walking/${lon1},${lat1};${lon2},${lat2}?geometries=geojson&access_token=pk.eyJ1IjoiaGlyby1oZWFsdGgiLCJhIjoiY2tma3VtcjNrMHc5aTJ5cGpkdTY3cjcwYSJ9.y5nSZRHPyyxApTmu_Aokcw`,
            transformRequest: [function (data, headers) {
                delete headers.common.Authorization;

                return {data, headers};
            }],
        })
    }

    getEncounterChildren(id) {
        return this.dataSource.get(`encounters/${id}/children`).then(({data}) => data)
    }

    getEncounterDetails(id) {
        return this.dataSource.get(`encounters/${id}/details`).then(({data}) => data);
    }

    deletePatientToken(id) {
        this.dataSource.delete(`fcm-tokens/${id}`).then(({data}) => data);
    }

    practitionerDescription(practitionerId) {
        return this.dataSource.get(`practitioners/${practitionerId}`).then(({data}) => data)
    }

    storePatientLocationLog(patientLocationLog) {
        return this.dataSource.post('locations/logs', patientLocationLog).then(({data}) => data)
    }
}
